import { sdk } from '@/services/sdk';
import { logActivity } from '@/shared/data';

/** Profiles that can open the console. */
export const TEAM_PROFILES = ['Admin_c', 'Staff_c'];

/** Every role the owner can hand out, from the most access to the least. */
export const ROLE_PROFILES = ['Admin_c', 'Staff_c', 'Customer_c'];

export const ROLE_LABELS = {
  Admin_c: 'Admin',
  Staff_c: 'Staff',
  Customer_c: 'Customer',
};

export const ROLE_STYLES = {
  Owner: 'border-highlight/40 bg-highlight/15 text-highlight',
  Admin: 'border-highlight/40 bg-highlight/15 text-highlight',
  Staff: 'border-primary/40 bg-primary/10 text-primary',
  Customer: 'border-border bg-muted text-muted-foreground',
};

export const ROLE_HINTS = {
  Admin_c: 'Full access, the same as you: everything, including broadcasts, the activity log and the Team page.',
  Staff_c: 'Orders, customers, payments, tickets, reviews, codes and content. No broadcasts or team.',
  Customer_c: 'A normal customer account again. They lose access to the console straight away.',
};

export const isTeamMember = (m) => TEAM_PROFILES.includes(m?.profile?.name);

export const memberName = (m) => m?.name || m?.email || 'This user';

const lower = (v) => String(v ?? '').trim().toLowerCase();

/** Every sign-in account on the app (team and customers), page by page. Owner only. */
export async function loadAllMembers() {
  const limit = 100;
  const out = [];
  for (let start = 0; start < 2000; start += limit) {
    const res = await sdk.teams.getMembers(start, limit);
    const page = res?.data ?? [];
    out.push(...page);
    if (!res?.hasMore || page.length < limit) break;
  }
  return out;
}

/** The sign-in account that uses this email, or null when they never signed up. */
export async function findMemberByEmail(email) {
  const wanted = lower(email);
  if (!wanted) return null;
  const all = await loadAllMembers();
  return all.find((m) => lower(m.email) === wanted) ?? null;
}

/** Give a member a new role and note it in the activity log. Throws when the platform refuses. */
export async function setMemberRole(member, profile) {
  await sdk.teams.updateMemberProfile(member.id, { profile });
  const action = profile === 'Customer_c' ? 'Removed from team' : profile === 'Admin_c' ? 'Made admin' : 'Role changed';
  logActivity('Team', action, member.email, ROLE_LABELS[profile] ?? profile);
}
